import React, { Component } from "react";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CROP_RATIOS } from "../../config/platformFeatures";
import { useTranslate } from "@tolgee/react";

interface CropProps {
  items: any[];
  updateCurrentCrop: Function;
  selectedCrop: any;
  platform: string;
}

const CropSelector: React.FC<CropProps> = ({
  items,
  updateCurrentCrop,
  selectedCrop,
  platform,
}) => {
  const { t } = useTranslate();
  return (
    <div
      style={{ overflowY: "auto" }}
      className="w-100 h-100 d-flex flex-column justify-content-start align-self-start align-items-start gap-2 mx-auto"
    >
      {items?.map((item, index) => {
        return (
          <div
            onClick={() => updateCurrentCrop(platform, item)}
            className={`cursor-pointer mx-auto`}
            style={{ width: "70px", height: "70px" }}
            key={`aspectratio-${item}`}
          >
            <div
              className={`${
                selectedCrop === item
                  ? "border border-primary "
                  : "border border-secondary"
              } d-flex flex-column gap-2 justify-content-center align-items-center position-relative rounded`}
              style={{ width: "70px", height: "70px" }}
            >
              <i
                style={{ fontSize: "22px" }}
                className={`${CROP_RATIOS[item]?.icon} text-dark`}
              ></i>
              <div style={{ fontSize: "10px" }} className="">
                {item === "0:0"
                  ? `${t("lomavisCreator.editorCropRatio.Custom")}`
                  : `${CROP_RATIOS[item].width}:${CROP_RATIOS[item].height}`}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CropSelector;
